module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_hiroshima-eae5bd6ba95242c50c4fb03c43ea1a83.jpg";